import React, { useState, useEffect} from 'react';
import { BASE_API } from '../../api/Globals';
import { helpHttp } from '../../helpers/helpHttp';
import Menu from '../../components/sturtural/Menu';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import Loader from '../../components/sturtural/Loader';
import { Dialog } from 'primereact/dialog';
import { useNavigate } from 'react-router-dom';
import { addLocale } from 'primereact/api'
import { storage } from '../../helpers/storage';

const ReporteCorteTienda = () => {
    const navigate = useNavigate();

    const [calendarValueInicio, setCalendarValueInicio] = useState(null);
    const [calendarValueFin, setCalendarValueFin] = useState(null);

    const [regioneles, setRegiones] = useState(null);
    const [loading_resgionales, setLoading_regionales] = useState(false);
	const [error_regionales, setErrors_regionales] = useState(false);
    const [regional, setRegional] = useState(-1);

    const [niveles, setNiveles] = useState(null);
    const [loading_niveles, setLoading_niveles] = useState(false);
	const [error_niveles, setErrors_niveles] = useState(false);
    const [nivel, setNivel] = useState(-1);

    const [aviso, setAviso] = useState(false);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(false);

    const perfil =  storage.get('perfilid');
    const ciclo =  storage.get('ciclo');

    useEffect(() => {
        if(![1, 2, 13, 17].includes(parseInt(perfil))) {
            return navigate('/login');
        }
    }, [perfil]);

    let url = `${BASE_API}BusquedaAlumnos/GetRptDelReg`;
    useEffect(() => {
        setLoading_regionales(true);
        helpHttp().get(url, {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            },
        }).then(res => {
            let response = res.ITEMS;
            if(response.SUCCESS === true) {
                setRegiones(response.ITEMS);
                setErrors_regionales(false);
            } else {
                setRegiones(null);
                setErrors_regionales('Error en la extracción de datos de REGIONALES');
            }
            setLoading_regionales(false);
        });
    },[url]);

    const handleSubmit_busqueda = () => {
        let body = {
            //"IdEscuela": calendarValueInicio,
            //"IdNivel": regional.code,
            //"IdDelRegional": nivel.code,
            
            "Tienda": storage.get('IdTienda'),
		    "Estatus": 2,
		    "IdEscuela": '-',
		    "IdNivel": -1,
		    "IdDelRegional": -1,
		    "Fecha": (calendarValueInicio === null || calendarValueInicio === undefined ? '1900' : calendarValueInicio),
            "FechaFin": (calendarValueFin === null || calendarValueFin === undefined ? "" : calendarValueFin),
            "IdCicloEscolar": ciclo.IdCicloEscolar
        };
        setLoading(true);
        helpHttp().post(`${BASE_API}BusquedaAlumnos/GetRptExcelAlumnos`, {
            body: body,
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            },
        }).then(res => {
            if(res.SUCCESS) {
                let excel = res.ITEMS.ITEMS;
                let temp = 'data:application/vnd.ms-excel;base64,' + encodeURIComponent(excel);
                let download = document.createElement('a');
                download.href = temp;
                download.download = `ReporteCorteExcel_${ciclo.Descripcion}.xlsx`;
                document.body.appendChild(download);
                download.click();
                document.body.removeChild(download);

                setLoading(false);
            } else {
                setMessage(res.ITEMS.MESSAGE);
                setAviso(true);

                setLoading(false);
            }
        });
    }
    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Limpiar'
    });



    const handlerRedirect = () => {
        setAviso(false);
    }

    const basicDialogFooter = <Button type="button" label="Aceptar" onClick={() => handlerRedirect()} icon="pi pi-check" className="p-button-secondary" />;

    return (
        <>
            <Menu link='reporte-general' />
            
            <div className="grid">
                <div className="col-12">
                    <div className="card">
                        <h3>Corte tienda</h3>
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-4">
                                <label htmlFor="regional">Fecha inicio:</label>
                                <Calendar locale='es' dateFormat="dd/mm/yy" showIcon showButtonBar value={calendarValueInicio} onChange={(e) => setCalendarValueInicio(e.value)}></Calendar>
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="nivel">Fecha fin:</label>
                                <Calendar dateFormat="dd/mm/yy" locale='es' showIcon showButtonBar value={calendarValueFin} onChange={(e) => setCalendarValueFin(e.value)}></Calendar>
                            </div>
                        </div>
                        <div className="p-dialog-footer">
                            <div className=" border-top-1 surface-border pt-3 text-right">
                                <Button 
                                    type='button' 
                                    name="button-generar" 
                                    id="button-generar" 
                                    disabled={loading} 
                                    icon={(loading ? 'pi pi-spin pi-spinner': 'pi pi-file-excel')} 
                                    label="Generar" 
                                    onClick={() => handleSubmit_busqueda()} 
                                />
                            </div>
                        </div>
                    </div>  
                </div>  
            </div>

            <Dialog header="Aviso" visible={aviso} onHide={() => setAviso(false)} style={{ width: '400px' }} modal className="p-fluid" footer={basicDialogFooter}>
                <p>{message && message}</p>
            </Dialog>
        </>
    )
}

export default ReporteCorteTienda;